/**
 * Created by mehmetyurtar on 31/08/2017.
 */


export const config = {
    parentElements: [
        {
            "label": "Firma Bilgileri",
            "name": "company-info",
            "isOpen": false
        },
        {
            "label": "Görseller",
            "name": "barcode-images",
            "isOpen": false
        },
        {
            "label": "Ürün Bilgileri",
            "name": "product-info",
            "isOpen": true
        },
        {
            "label": "Metin Alanı",
            "name": "other-notes",
            "isOpen": false
        }
    ],
    mainElements: [
        {
            "label": "Firma Ünvanı",
            "variableName": "company_name",
            "icon": "user",
            "parentName": "company-info",
            "placeHolder": "Firma Ünvanı",
            "width": 160,
            "height": 35
        },
        {
            "label": "Firma Adresi",
            "variableName": "address",
            "icon": "map-marker",
            "parentName": "company-info",
            "placeHolder": "Firma Adresi bir mah. no:1 daire:1 ilçe,il",
            "width": 160,
            "height": 35
        },
        {
            "label": "Firma Email",
            "variableName": "email",
            "icon": "envelope",
            "parentName": "company-info",
            "placeHolder": "ornek@ekohesap.com",
            "width": 160,
            "height": 35
        },
        {
            "label": "Firma Telefon",
            "variableName": "phone",
            "icon": "phone",
            "parentName": "company-info",
            "placeHolder": "05555555555",
            "width": 160,
            "height": 35
        },
        {
            "label": "Vergi Numarası",
            "variableName": "tax_identity_number",
            "icon": "gavel",
            "parentName": "company-info",
            "placeHolder": "123456789",
            "hidden": false,
            "width": 160,
            "height": 35
        },
        {
            "label": "Barkod",
            "variableName": "barcode",
            "icon": "barcode",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/barcode.png'>",
            "height":100,
            "width":200,
        },
        {
            "label": "Yerli Üretim Görseli (Renkli)",
            "variableName": "yerli_uretim_1",
            "icon": "image",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/yerli_uretim.png'>",
            "height":100,
            "width":200,
        },
        {
            "label": "Yerli Üretim Görseli (Siyah)",
            "variableName": "yerli_uretim_2",
            "icon": "image",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/yerli_uretim_2.jpg'>",
            "height":100,
            "width":200,
        },
        {
            "label": "Ürün Görseli",
            "variableName": "product_image",
            "icon": "image",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/product.png'>",
            "height":100,
            "width":200,
        },
        {
            "label": "İndirim Görseli 1",
            "variableName": "discount_image_1",
            "icon": "arrow-down",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/indirim_1.png'>",
            "height":100,
            "width":200,
        },

        {
            "label": "İndirim Görseli 2",
            "variableName": "discount_image_2",
            "icon": "arrow-down",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/indirim_2.png'>",
            "height":100,
            "width":200,
        },
        {
            "label": "İndirim Görseli 3",
            "variableName": "discount_image_3",
            "icon": "arrow-down",
            "parentName": "barcode-images",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/indirim_3.jpg'>",
            "height":100,
            "width":200,
        },
        {
            "label": "Hizmet / Ürün Kalemleri",
            "variableName": "hizmet1",
            "icon": "bars",
            "parentName": "service-info",
            "placeHolder": "123456789",
            "isFixedTable": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Ürün Adı",
            "variableName": "product_name",
            "icon": "underline",
            "parentName": "product-info",
            "placeHolder": "Ürün Adı",
            "width": 160,
            "height": 35
        },
        {
            "label": "Ürün Kodu",
            "variableName": "product_code",
            "icon": "underline",
            "parentName": "product-info",
            "placeHolder": "U123",
            "width": 160,
            "height": 35
        },
        {
            "label": "Birim",
            "variableName": "product_unit_name",
            "icon": "list",
            "parentName": "product-info",
            "placeHolder": "Adet",
            "width": 160,
            "height": 35
        },
        {
            "label": "Ürün Grubu",
            "variableName": "product_group",
            "icon": "list-ul",
            "parentName": "product-info",
            "placeHolder": "Ürün Grubu Adı",
            "width": 160,
            "height": 35
        },
        {
            "label": "KDV Oranı",
            "variableName": "product_vat_rate",
            "icon": "money-bill",
            "parentName": "product-info",
            "placeHolder": "%20",
            "width": 160,
            "height": 35
        },
        {
            "label": "Satış Fiyatı (KDV Dahil)",
            "variableName": "product_vat_included_price",
            "icon": "money-bill",
            "parentName": "product-info",
            "placeHolder": "100,00 TL",
            "width": 160,
            "height": 35
        },{
            "label": "Satış Fiyatı (KDV Hariç)",
            "variableName": "product_vat_excluded_price",
            "icon": "money-bill",
            "parentName": "product-info",
            "placeHolder": "80,00 TL",
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 1",
            "variableName": "freeText1",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 2",
            "variableName": "freeText2",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 3",
            "variableName": "freeText3",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 4",
            "variableName": "freeText4",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 5",
            "variableName": "freeText5",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 6",
            "variableName": "freeText6",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 7",
            "variableName": "freeText7",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 8",
            "variableName": "freeText8",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 9",
            "variableName": "freeText9",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
        {
            "label": "Metin Alanı 10",
            "variableName": "freeText10",
            "icon": "text-width",
            "parentName": "other-notes",
            "placeHolder": "Örnek Metin",
            "isFreeText": true,
            "width": 160,
            "height": 35
        },
    ],
    tableFields: [
        {
            "variableName": "item_name",
            "label": "Hizmet/Ürün",
            "labelOnTable": "Hizmet veya ürün adı",
            "descOnTable": "Hizmet veya ürün aciklamasi",
            "checked": true,
            "width": 300,
            "order": 0
        },
        {
            "variableName": "item_code",
            "label": "Kod",
            "checked": true,
            "labelOnTable": "#",
            "width": 96,
            "order": 1
        },
        {
            "variableName": "description",
            "label": "Aciklama",
            "labelOnTable": "Hizmet veya ürün açıklaması",
            "checked": true,
            "width": 150,
            "order": 2
        },
        {
            "variableName": "quantity",
            "label": "Miktar",
            "labelOnTable": "1",
            "checked": true,
            "width": 58,
            "order": 3
        },
        {
            "variableName": "unit",
            "label": "Birim",
            "labelOnTable": "birim",
            "checked": false,
            "width": 100,
            "order": 4
        },
        {
            "variableName": "unit_price",
            "label": "Birim Fiyat",
            "labelOnTable": "1.000,00",
            "checked": false,
            "width": 87,
            "order": 5
        },
        {
            "variableName": "net_amount",
            "label": "Tutar",
            "labelOnTable": "1.000,00",
            "checked": false,
            "width": 87,
            "order": 5
        },
        {
            "variableName": "discount_amount",
            "label": "İndirim",
            "labelOnTable": "0,00",
            "checked": false,
            "width": 100,
            "order": 6
        },
        {
            "variableName": "vat_amount",
            "label": "KDV Miktar",
            "labelOnTable": "200",
            "checked": false,
            "width": 100,
            "order": 7
        },
        {
            "variableName": "vat_amount_percent",
            "label": "KDV Yüzde",
            "labelOnTable": "%20",
            "checked": false,
            "width": 100,
            "order": 7
        },
        {
            "variableName": "total_amount",
            "label": "Toplam",
            "labelOnTable": "1.000,00",
            "checked": false,
            "width": 100,
            "order": 8
        }
    ],
    canvasElements: [
        {
            "fontSize": "24",
            "isBold": false,
            "isItalic": false,
            "textAlign": "left",
            "width": 160,
            "height": 35,
            "fontFamily": "'PT Sans', sans-serif",
            "fontWeight": "normal",
            "fontStyle": "normal",
            "variableName": "company_name",
            "label": "Firma Ünvanı",
            "placeHolder": "Firma Ünvanı",
            "positionX": 10,
            "positionY": 10,
            "parentName": "company-info"
        },
        {
            "fontSize": "20",
            "isBold": false,
            "isItalic": false,
            "textAlign": "left",
            "width": 160,
            "height": 35,
            "fontFamily": "'PT Sans', sans-serif",
            "fontWeight": "normal",
            "fontStyle": "normal",
            "variableName": "product_name",
            "label": "Ürün Adı",
            "placeHolder": "Ürün Adı",
            "positionX": 10,
            "positionY": 50,
            "parentName": "product-info"
        },
        {
            "fontSize": "14",
            "isBold": false,
            "isItalic": false,
            "textAlign": "left",
            "width": 210,
            "height": 20,
            "fontFamily": "'PT Sans', sans-serif",
            "fontWeight": "normal",
            "fontStyle": "normal",
            "variableName": "date",
            "label": "Fiyat Değişiklik Tarihi",
            "placeHolder": "Fiyat Değişiklik Tarihi: 01-01-2025",
            "positionX": 180,
            "positionY": 210,
            "parentName": "barcode-images"
        },
        {
            "fontSize": "24",
            "isBold": true,
            "isItalic": false,
            "textAlign": "left",
            "fontFamily": "'PT Sans', sans-serif",
            "fontWeight": "normal",
            "fontStyle": "normal",
            "variableName": "product_vat_included_price",
            "label": "Tutar",
            "placeHolder": "100,00 TL",
            "positionX": 10,
            "positionY": 100,
            "parentName": "product-info",
            "width": 170,
            "height": 35
        },
        {
            "fontSize": "24",
            "isBold": false,
            "isItalic": false,
            "textAlign": "left",
            "width": 200,
            "height": 100,
            "fontFamily": "'PT Sans', sans-serif",
            "fontWeight": "normal",
            "fontStyle": "normal",
            "variableName": "barcode",
            "label": "Barkod Görseli",
            "placeHolder": "<img style='width:100%' src='https://earsiv.co/images/barcode_images/barcode.png'>",
            "positionX": 190,
            "positionY": 10,
            "parentName": "barcode-images"
        },
    ],
    selectedEl: {
        "variableName": "write_total",
        "label": "Yazı ile Toplam",
        "placeHolder": "Yüz bin",
        "positionX": 18,
        "positionY": 616,
        "parentName": "product-info",
        "width": 100,
        "height": 20
    },
    paperWidth: 400,
    paperHeight: 240,
    paperWidthCm: 5,
    paperHeightCm: 3,
    paperOrientation: "v",
    paperBackground: "",
    useDescriptionWithProduct: false,
    componentDefaults: {
        "fontSize":   "24",
        "isBold": false,
        "isItalic": false,
        "textAlign": "left",
        "width": 200,
        "height": 35,
        "fontFamily": "'PT Sans', sans-serif",
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    componentDefaultsImg: {
        "fontSize":   "24",
        "isBold": false,
        "isItalic": false,
        "textAlign": "left",
        "width": 200,
        "height": 90,
        "fontFamily": "'PT Sans', sans-serif",
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    isElementSelected: true,
    customPaperSize: false,
    isPrinting: false,
    mainElversion: 0,
    templateName: "Yeni Şablon"
};

export default config;